import { h, Component } from 'preact';
import { translate } from 'react-i18next';

class NotificationBanner extends Component {

	updateType = (type) => {
		switch (type) {
			case 'success':
				this.setState({ type: 'success' });
				break;
			case 'warn':
				this.setState({ type: 'warn' });
				break;
			case 'fail':
				this.setState({ type: 'fail' });
				break;
			default:
				this.setState({ type: 'hidden' });
		}
	}

	constructor(props) {
		super(props);
		this.updateType(this.props.type);
	}

	shouldComponentUpdate(nextProps) {
		if (this.props.type !== nextProps.type) {
			this.updateType(nextProps.type)
		}
		if (nextProps.time) {
			setTimeout(() => {
				this.updateType('hidden');
			}, nextProps.time);
		}
	}

	render() {
		const { t } = this.props;
		return (
			<div className={`notification ${this.state.type}`}>
				<p>{t(this.props.copy)}</p>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(NotificationBanner);


// WEBPACK FOOTER //
// ./components/NotificationBanner.js